import React, { useState, useEffect } from "react";
import { FacebookShareButton, LineShareButton } from "react-share";
import moment from "moment";
import "moment-duration-format";
import Swal from "sweetalert2";
import { trackButtonClick } from "../../services/googleSheetsService";

// components
// import IndexPage from "./IndexPage";
import PageTitle from "../../components/PageTitle/PageTitle";
import FullTimer from "./components/FullTimer";
import HalfTimer from "./components/HalfTimer";
import CountdownTimer from "../../components/CountdownTimer/CountdownTimer";

// data
import TimerNote_data from "./data/timerNote.json";

//image
import TaipetMarathon_Map_Full from "../../assets/images/marathon-map.webp";
import TaipetMarathon_Map_Half from "../../assets/images/half-marathon-map.webp";
import running_icon_before from "../../assets/images/icons8-human-100.png";
import running_icon_after from "../../assets/images/icons8-jogging-for-cardio-exercise-to-enhance-stamina-96.png";
import share_fb from "../../assets/images/facebook.png";
// import share_ig from "../../assets/images/instagram.png";
import share_line from "../../assets/images/line.png";
import station_icon from "../../assets/images/station-icon.png";
import station_icon_noselect from "../../assets/images/station-icon-noSeleted.png";
import tpe_logo from "../../assets/images/TaipeiMarethon/taipei-main.webp";

function TaipeiMarathonTimer() {
    const [raceTime, setRaceTime] = useState({
        hours: "",
        minutes: "",
        seconds: "",
        hydrationTime: "",
    });
    const [results, setResults] = useState({
        hydrationStations: [false, ...Array.from({ length: 15 }, () => true), false],
        note: Array.from({ length: 17 }, (_, index) => TimerNote_data.fullNotesArray[index] || ""),
        formattedCumulativeTimes: [],
        formattedZoneTimes: [],
    });

    // * 半馬計算
    const [results_half, setResults_half] = useState({
        hydrationStations: [false, ...Array.from({ length: 7 }, () => true), false],
        note: Array.from({ length: 9 }, (_, index) => TimerNote_data.halfNoteArray[index] || ""),
        formattedCumulativeTimes_half: [],
        formattedZoneTimes_half: [],
    });
    const [selectedGroup, setSelectedGroup] = useState("full"); // step1 選擇組別按鈕

    //  輸入時間
    const handleRaceTimeChange = (event, field, min, max) => {
        let value = parseInt(event.target.value) || 0;
        value = Math.min(Math.max(value, min), max);

        setRaceTime((prevRaceTime) => ({ ...prevRaceTime, [field]: value }));
    };

    // * 轉換秒數為正規時間
    const formatTime = (timeInSeconds) => {
        const duration = moment.duration(timeInSeconds, "seconds");
        return duration.format("HH:mm:ss", { trim: false });
    };
    // * 轉換秒數為分跟秒
    const formatMMSS = (timeInSeconds) => {
        const duration = moment.duration(timeInSeconds, "seconds");
        return duration.format("mm:ss", { trim: false });
    };
    // 補給站點選
    const handleHydrationStationsChange = (event, index) => {
        const newStations = [...results.hydrationStations];
        const isChecked = !newStations[index];
        newStations[index] = isChecked;
        setResults((prevResults) => ({
            ...prevResults,
            hydrationStations: newStations,
        }));
    };
    // *補給站點選_半馬
    const handleHydrationStationsChange_half = (event, index) => {
        const newStations = [...results_half.hydrationStations];
        const isChecked = !newStations[index];
        newStations[index] = isChecked;
        setResults_half((prevResults) => ({
            ...prevResults,
            hydrationStations: newStations,
        }));
    };

    // !在這裡進行計算邏輯，更新results狀態
    const calculateResults = () => {
        let totalRaceTimeInSeconds =
            raceTime.hours * 3600 + raceTime.minutes * 60 + raceTime.seconds;

        // 計算補給時間
        let totalHydrationTime = 0;
        results.hydrationStations.forEach((isChecked, index) => {
            if (isChecked) {
                totalHydrationTime += raceTime.hydrationTime;
            }
        });
        // *計算補給時間_半馬
        let totalHydrationTime_half = 0;
        results_half.hydrationStations.forEach((isChecked, index) => {
            if (isChecked) {
                totalHydrationTime_half += raceTime.hydrationTime;
            }
        });

        // 地形時間 = 使用者輸入時間 帶入
        let terrainParameters =
            raceTime.hours / 24 + raceTime.minutes / 24 / 60 + raceTime.seconds / 24 / 60 / 60;
        // 根據完賽時間計算地形參數
        const terrainParameter1 = Math.round(15 + (terrainParameters - 0.17) * 240);
        const terrainParameter2 = Math.round(5 + (terrainParameters - 0.17) * 40);
        const terrainParameter3 = Math.round(10 + (terrainParameters - 0.13) * 120);
        const terrainParameter4 = Math.round(-5 - (terrainParameters - 0.13) * 100);
        // 將四個區段的地形參數加總
        const totalTerrainParameter =
            (terrainParameter1 + terrainParameter2 + terrainParameter3 + terrainParameter4) * 2.5;

        // *根據完賽時間計算地形參數_半馬
        const terrainParameter1_half = 4 + Math.round((terrainParameters - 0.055) * 300);
        const terrainParameter2_half = 3 + Math.round((terrainParameters - 0.055) * 230);
        const terrainParameter3_half = 4 + Math.round((terrainParameters - 0.055) * 160);
        const terrainParameter4_half = 4 + Math.round((terrainParameters - 0.055) * 160);
        const terrainParameter5_half = -5;
        // *將四個區段的地形參數加總＿半馬
        const totalTerrainParameter_half =
            (terrainParameter1_half +
                terrainParameter2_half +
                terrainParameter3_half +
                terrainParameter4_half +
                terrainParameter5_half) *
            1.1;

        // 扣除兩項DIFF的平均配速
        const averagePace =
            (totalRaceTimeInSeconds - totalHydrationTime - totalTerrainParameter) / 42.4;
        // *扣除兩項DIFF的平均配速_半馬
        const averagePace_half =
            (totalRaceTimeInSeconds - totalHydrationTime_half - totalTerrainParameter_half) / 21.4;

        // 計算區間配速
        const intervalPaceArr = Array.from({ length: 17 }, (_, index) => index);
        const intervalPace = intervalPaceArr.map((index) => {
            // 對需要納入地形參數的區間應用地形參數，其他區間保持原樣
            const terrainFactor = [
                terrainParameter1,
                1,
                1,
                1,
                1,
                terrainParameter2,
                1,
                1,
                terrainParameter3,
                1,
                terrainParameter4,
                1,
                1,
                1,
                1,
                1,
                1,
            ];
            return formatTime(averagePace + terrainFactor[index]);
        });

        // *計算區間配速_半馬
        const intervalPaceArr_half = Array.from({ length: 9 }, (_, index) => index);
        const intervalPace_half = intervalPaceArr_half.map((index) => {
            // 對需要納入地形參數的區間應用地形參數，其他區間保持原樣
            const terrainFactor = [
                terrainParameter1_half,
                terrainParameter2_half,
                1,
                1,
                terrainParameter3_half,
                1,
                terrainParameter4_half,
                1,
                terrainParameter5_half,
            ];
            return formatTime(averagePace_half + terrainFactor[index]);
        });

        // 計算區間離站
        const zoneDistances = Array.from({ length: 17 }, (_, index) => (index === 16 ? 2.2 : 2.5)); // 計算每個區間的距離
        const zoneTimes = zoneDistances.map(
            (distance, index) => distance * moment.duration(intervalPace[index]).asSeconds()
        );

        // *計算區間離站_半馬
        const zoneDistances_half = Array.from({ length: 9 }, (_, index) =>
            index === 8 ? 1.1 : 2.5
        ); // 計算每個區間的距離
        const zoneTimes_half = zoneDistances_half.map(
            (distance, index) => distance * moment.duration(intervalPace_half[index]).asSeconds()
        );

        // 計算每個區間的累計時間
        const cumulativeTimes = [];
        let lastCumulativeTime = 0;
        zoneTimes.forEach((time, index) => {
            const cumulativeTimeWithHydration =
                lastCumulativeTime +
                time +
                (results.hydrationStations[index] && raceTime.hydrationTime !== ""
                    ? raceTime.hydrationTime
                    : 0);
            cumulativeTimes.push(cumulativeTimeWithHydration);
            lastCumulativeTime = cumulativeTimeWithHydration;
        });
        // *計算每個區間的累計時間_半馬
        const cumulativeTimes_half = [];
        let lastCumulativeTime_half = 0;
        zoneTimes_half.forEach((time, index) => {
            const cumulativeTimeWithHydration_half =
                lastCumulativeTime_half +
                time +
                (results_half.hydrationStations[index] && raceTime.hydrationTime !== ""
                    ? raceTime.hydrationTime
                    : 0);
            cumulativeTimes_half.push(cumulativeTimeWithHydration_half);
            lastCumulativeTime_half = cumulativeTimeWithHydration_half;
        });

        // 將區間時間轉換為格式化的時間
        const formattedZoneTimes = intervalPace.map((time, index) =>
            index === 16 ? formatMMSS(cumulativeTimes[16] / 42.3) : formatMMSS(time)
        );
        const formattedCumulativeTimes = cumulativeTimes.map((time) => formatTime(time));

        // *將區間時間轉換為格式化的時間_半馬
        const formattedZoneTimes_half = intervalPace_half.map((time, index) =>
            index === 9 ? formatMMSS(cumulativeTimes_half[9] / 21.4) : formatMMSS(time)
        );
        const formattedCumulativeTimes_half = cumulativeTimes_half.map((time) => formatTime(time));

        // 更新計算結果狀態
        setResults((prevResults) => ({
            ...prevResults,
            formattedZoneTimes,
            formattedCumulativeTimes,
        }));
        // 更新計算結果狀態
        setResults_half((prevResults) => ({
            ...prevResults,
            formattedZoneTimes_half,
            formattedCumulativeTimes_half,
        }));
    };

    const chrckInput = () => {
        if (!raceTime.hours && !raceTime.minutes && !raceTime.seconds) {
            Swal.fire({
                icon: "info",
                text: "請輸入預計完賽時間",
            });
            return true;
        }
        return false;
    };

    const [handleSubmita, setHandleSubmita] = useState(false);
    useEffect(() => {
        if (!handleSubmita) {
            return;
        }
        calculateResults();
    }, [results.hydrationStations, results_half.hydrationStations]);

    // 點擊送出後計算出總時間
    const handleSubmit = () => {
        trackButtonClick("2025台北馬拉松-計算配速", "GO");
        if (chrckInput()) {
            return;
        }
        setHandleSubmita(true);
        handleHydrationStationsChange();
        handleHydrationStationsChange_half();
    };
    // 切換全馬半馬
    const renderSelectedGroup = () => {
        return (
            <div>
                {selectedGroup === "full" ? (
                    <FullTimer
                        handleHydrationStationsChange={handleHydrationStationsChange}
                        results={results}
                        formatTime={formatTime}
                        formatMMSS={formatMMSS}
                        raceTime={raceTime}
                        showYoutubeVideo={showYoutubeVideo}
                        handleShowMap={handleShowMap}
                        chrckInput={chrckInput}
                    />
                ) : (
                    <HalfTimer
                        handleHydrationStationsChange_half={handleHydrationStationsChange_half}
                        results_half={results_half}
                        formatTime={formatTime}
                        formatMMSS={formatMMSS}
                        raceTime={raceTime}
                        showYoutubeVideo={showYoutubeVideo}
                        handleShowMap={handleShowMap}
                        chrckInput={chrckInput}
                    />
                )}
            </div>
        );
    };

    // 組別按鈕狀態管理
    const handleGroupClick = (group) => {
        trackButtonClick(`2025台北馬拉松-選擇組別-${group === "full" ? "全馬" : "半馬"}`, "#");
        if (!group) {
            Swal.fire({
                icon: "info",
                text: "請先選擇組別",
                customClass: {
                    confirmButton: "custom-confirm-button",
                },
                showConfirmButton: true,
                confirmButtonText: "確認",
            });
            return;
        }
        setSelectedGroup(group); // 直接將選中的組別設定為點擊的組別
    };

    const handleShowMap = () => {
        const imageUrl =
            selectedGroup === "full" ? TaipetMarathon_Map_Full : TaipetMarathon_Map_Half;
        Swal.fire({
            imageUrl: imageUrl,
            width: 800,
            height: 500,
            imageAlt: "賽道地圖",
            showCloseButton: true,
            showConfirmButton: false,
        });
    };

    const showYoutubeVideo = () => {
        const FullVideo_Url = "https://www.youtube.com/embed/QCgbw079hsM?si=JCJ3owKRj-4Fjjx6";
        const HalfVideo_Url = "https://www.youtube.com/embed/m2Cw0BI-SVE?si=qAHQ6UAk_i3C9-pB";
        const vidioUrl = selectedGroup === "full" ? FullVideo_Url : HalfVideo_Url;

        Swal.fire({
            html: `<iframe width="100%" height="315" src="${vidioUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`,
            customClass: {
                content: "youtube-video-popup",
            },
            widthAuto: true,
            heightAuto: true,
            showCloseButton: true,
            showConfirmButton: false,
        });
    };

    const shareUrl = "https://catvv.tw";

    return (
        <>
            {/* <IndexPage /> */}
            <section className="content-section" id="marathon-timer">
                <div className="">
                    <PageTitle
                        title={"2025 台北馬拉松配速計算機"}
                        titleTag={["全馬", "半馬"]}
                        descriptionLines={[
                            "輸入預計完賽時間",
                            "直接計算專屬於台北馬的各區間配速！",
                        ]}
                        titleStyle={{ color: "#00307C" }}
                    />
                    <section className="timer-section">
                        <div className="step-wrap">
                            <div className="step nagoya-main-img-mobile">
                                <a
                                    href="https://www.taipeicitymarathon.com/"
                                    target="_blank"
                                    rel="noreferrer"
                                    title="台北馬拉松官方網站"
                                    onClick={() =>
                                        trackButtonClick(
                                            "2025台北馬拉松-官方網站",
                                            "https://www.taipeicitymarathon.com/"
                                        )
                                    }
                                >
                                    <div className="nagoya-main-img">
                                        <img
                                            className=""
                                            src={tpe_logo}
                                            alt="台北馬拉松官方網站形象圖片"
                                        />
                                    </div>
                                </a>
                            </div>
                            <CountdownTimer raceTime={"2025-12-21T06:30:00+08:00"} />
                            <div className="step">
                                <h2 className="timerStep-wrap">
                                    <span>STEP 1</span>選擇參賽組別
                                    {selectedGroup === null
                                        ? ""
                                        : selectedGroup === "full"
                                        ? " - 全馬"
                                        : " - 半馬"}
                                </h2>
                                <div className="group-wrap">
                                    <div className="group-button-wrap">
                                        <button
                                            className={`group-btn ${
                                                selectedGroup === "full" ? "active" : ""
                                            }`}
                                            onClick={() => handleGroupClick("full")}
                                        >
                                            {selectedGroup === "full" ? (
                                                <i
                                                    className="fa-solid fa-angles-down animate__animated animate__bounce animate__fadeInDown animate__infinite"
                                                    style={{ color: "#000000" }}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <img
                                                src={
                                                    selectedGroup === "full"
                                                        ? running_icon_after
                                                        : running_icon_before
                                                }
                                                alt=""
                                            />
                                            <p>全程馬拉松</p>
                                        </button>
                                        <button
                                            className={`group-btn ${
                                                selectedGroup === "half" ? "active" : ""
                                            }`}
                                            onClick={() => handleGroupClick("half")}
                                        >
                                            {selectedGroup === "half" ? (
                                                <i
                                                    className="fa-solid fa-angles-down animate__animated animate__bounce animate__fadeInDown animate__infinite"
                                                    style={{ color: "#000000" }}
                                                ></i>
                                            ) : (
                                                ""
                                            )}
                                            <img
                                                src={
                                                    selectedGroup === "half"
                                                        ? running_icon_after
                                                        : running_icon_before
                                                }
                                                alt=""
                                            />
                                            <p>半程馬拉松</p>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="step">
                                <h2 className="timerStep-wrap">
                                    <span>STEP 2</span>設定比賽目標
                                </h2>
                                <div className="timer-input-card ">
                                    <form>
                                        <h3>預計完賽時間</h3>
                                        <div className="timerInput-wrap">
                                            <input
                                                type="number"
                                                id="hours"
                                                value={raceTime.hours === "" ? "" : raceTime.hours}
                                                onChange={(e) =>
                                                    handleRaceTimeChange(e, "hours", 0, 23)
                                                }
                                                placeholder="時"
                                                aria-labelledby="hours-aria"
                                            />
                                            <span>：</span>
                                            <input
                                                type="number"
                                                id="minutes"
                                                value={
                                                    raceTime.minutes === "" ? "" : raceTime.minutes
                                                }
                                                onChange={(e) =>
                                                    handleRaceTimeChange(e, "minutes", 0, 59)
                                                }
                                                placeholder="分"
                                                aria-labelledby="minutes-aria"
                                            />
                                            <span>：</span>
                                            <input
                                                type="number"
                                                id="seconds"
                                                value={
                                                    raceTime.seconds === "" ? "" : raceTime.seconds
                                                }
                                                onChange={(e) =>
                                                    handleRaceTimeChange(e, "seconds", 0, 59)
                                                }
                                                placeholder="秒"
                                                aria-labelledby="seconds-aria"
                                            />
                                        </div>
                                        <h3>進站單站停留秒數</h3>
                                        <div className="timerInput-wrap">
                                            <input
                                                type="number"
                                                id="hydrationTime"
                                                value={
                                                    raceTime.hydrationTime === ""
                                                        ? ""
                                                        : raceTime.hydrationTime
                                                }
                                                onChange={(e) =>
                                                    handleRaceTimeChange(e, "hydrationTime", 0, 99)
                                                }
                                                placeholder="秒"
                                                aria-labelledby="stationTime-aria"
                                            />
                                            <div className="result-button" onClick={handleSubmit}>
                                                GO
                                            </div>
                                        </div>
                                    </form>
                                    <div className="stationIcon-wrap">
                                        <p>點選配速表內水杯計算補給時間</p>
                                        <img
                                            src={station_icon_noselect}
                                            alt="補給站水杯（未勾選）"
                                        />
                                        ＞
                                        <img src={station_icon} alt="補給站水杯（勾選）" />
                                        <div className="station-icon">
                                            <i
                                                className="fa-solid fa-angles-down animate__animated animate__bounce animate__fadeInDown animate__infinite"
                                                style={{ color: "#ffffff" }}
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="step nagoya-main-img-pc">
                                <a
                                    href="https://www.taipeicitymarathon.com/"
                                    target="_blank"
                                    rel="noreferrer"
                                    title="台北馬拉松官方網站"
                                    onClick={() =>
                                        trackButtonClick(
                                            "2025台北馬拉松-官方網站",
                                            "https://www.taipeicitymarathon.com/"
                                        )
                                    }
                                >
                                    <div className="nagoya-main-img">
                                        <img className="" src={tpe_logo} alt="台北馬拉松形象圖片" />
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="step3-wrap">
                            <div className="step3-title-wrap">
                                <h2 className="timerStep-wrap">
                                    <span>STEP 3</span>建議配速策略
                                </h2>
                                <div className="share-warp">
                                    <div
                                        onClick={() =>
                                            trackButtonClick("2025台北馬拉松-分享FB", shareUrl)
                                        }
                                    >
                                        <FacebookShareButton url={shareUrl}>
                                            <img src={share_fb} alt="FB分享icon" />
                                        </FacebookShareButton>
                                    </div>
                                    {/* <InstapaperShareButton url={shareUrl}>
                                        <img src={share_ig} alt="IG分享icon" />
                                    </InstapaperShareButton> */}

                                    <div
                                        onClick={() =>
                                            trackButtonClick("2025台北馬拉松-分享Line", shareUrl)
                                        }
                                    >
                                        <LineShareButton url={shareUrl}>
                                            <img src={share_line} alt="Line分享icon" />
                                        </LineShareButton>
                                    </div>
                                </div>
                            </div>
                            {/* render results card componemts */}
                            {renderSelectedGroup()}
                        </div>
                    </section>
                </div>
            </section>
        </>
    );
}

export default TaipeiMarathonTimer;
